export const API_URL = 'https://www.kuruuch.xyz/api'; 
export const SHARE_URL = 'https://www.kuruuch.xyz/';
export const API_LOGIN = '/login';

export const API_POST_ORDER = '/orders';
export const API_PUT_ORDER = '/orders/';
export const API_GET_ONE_ORDER = '/orders/';
export const API_GET_ORDERS = '/orders_user/';
export const API_CHANGE_STATE = '/change_state/';
export const API_GET_PRICES = '/prices';





// WEBPACK FOOTER //
// ./src/constants.ts